// extracted by mini-css-extract-plugin
export var replyText = "CommentContext-module--reply-text--35kck";